import React from 'react';
import { Alert, Button, Input } from 'antd';
import Title from 'antd/es/typography/Title';
import ShippingAddressSwitcher from '../shippingAddressSwitcher';
import Spinner from '../spinner/Spinner';
import ShippingFields from './helpers/ShippingFields';
import { useShippingAddressForm } from './helpers/useShippingAddressForm';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { setGuestEmail } from '../../redux/slices/shoppingCartSlice';
import './shipping.scss';

const Shipping: React.FC = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.user);
  const guestEmail = useAppSelector((state) => state.shoppingCart.guestEmail);
  const {
    addressValidationMessage,
    buttonText,
    errors,
    handleAddressChange,
    handleDeleteCurrentAddress,
    handlePrimaryAction,
    handleCountryChange,
    handleProvinceChange,
    isCheckoutPage,
    loading,
    setAddressValidationMessage,
    setUserInfo,
    shipping,
    updateButtonClicked,
    userInfo,
  } = useShippingAddressForm();
  const shouldShowAddressSwitcher = !isCheckoutPage || !shipping?.useAddressForBilling;
  const shouldShowGuestEmail = isCheckoutPage && !user?.id;

  return (
    <div className="shipping-container">
      <Title className="shipping-heading" level={3}>Your Delivery Addresses</Title>
      {shouldShowAddressSwitcher && (
        <ShippingAddressSwitcher onAddressSelect={handleAddressChange} />
      )}

      {loading ? (
        <div className="shipping-spinner">
          <Spinner />
        </div>
      ) : (
        <>
          {shouldShowGuestEmail && (
            <div className="shipping-guest-email">
              <label className="input-label" htmlFor="guest-email">Email</label>
              <Input
                id="guest-email"
                value={guestEmail}
                onChange={(event) => dispatch(setGuestEmail(event.target.value))}
                placeholder="email@example.com"
                type="email"
              />
            </div>
          )}

          <ShippingFields
            errors={errors}
            handleCountryChange={handleCountryChange}
            handleProvinceChange={handleProvinceChange}
            setAddressValidationMessage={setAddressValidationMessage}
            setUserInfo={setUserInfo}
            updateButtonClicked={updateButtonClicked}
            userInfo={userInfo}
          />

          {addressValidationMessage && (
            <Alert
              className="shipping-alert"
              type="error"
              showIcon
              message={addressValidationMessage}
            />
          )}

          <div className="button-container">
            <Button type="primary" onClick={handlePrimaryAction} disabled={loading}>
              {buttonText}
            </Button>
            {!isCheckoutPage && shipping?.id && (
              <Button danger onClick={handleDeleteCurrentAddress} disabled={loading}>
                Delete Current Address
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Shipping;
